const filterHeaders = document.querySelectorAll(".filter-tab__header");
filterHeaders.forEach((fh) => {
  fh.addEventListener("click", function(e) {
    this.classList.toggle("filteropen");
    $(this.closest(".collection__filter-tab").querySelector(".filter-tab__content")).slideToggle(300);
  });
});


const currentTags = [];
const filterActionBtns = document.querySelectorAll(".filteraction");
filterActionBtns.forEach((ftbtn) => {
  ftbtn.addEventListener("click", async function(e) {
    // Checkbox Case
    if(this.parentElement.classList.contains("general-checkbox")) {
      if(this.checked) currentTags.push(this.value);
      else removeTag(currentTags, this.value);
    }

    // Button Case
    if(this.parentElement.classList.contains("filter-button__container")) {
      this.classList.toggle("filteractive");

      const toggleStatus = this.classList.contains("filteractive");
      if(toggleStatus) currentTags.push(this.value);
      else removeTag(currentTags, this.value);
    }

    // Fetch filtered collection data with the saved tags
    const colUrl = this.closest(".collection-template").dataset.sectionUrl;

    let newCollectionData = "";

    if(currentTags.length == 0) {
    	newCollectionData = await fetchCollectionData(colUrl);
    }

    console.log(currentTags);

    for(let i = 0; i < currentTags.length; i++) {
      // let newUrl = colUrl + "/" + currentTags[i];
     const tagHandle = "/" + currentTags.join("+");
      let newUrl = colUrl + tagHandle;
      console.log(newUrl);
      if( i == 0 ) {
        newCollectionData = await fetchCollectionData(newUrl);
      } else {
         let additionalTag = await fetchCollectionData(newUrl);
         let nodeList = additionalTag.querySelectorAll(":scope > div");
         for(let i = 0; i < nodeList.length; i++) {
           	// newCollectionData.appendChild(nodeList[i]);
         }
      }

    }

    console.log(newCollectionData);

    // Replace current collection page with the newly fetched one
    const currentData = this.closest(".collection-template").querySelector(".collection__products-body");
    currentData.innerHTML = newCollectionData.innerHTML;
  });
});

const removeTag = (arr, element) => {
  const index = arr.indexOf(element);
  if(index != -1)
    arr.splice(index, 1);
}

const fetchCollectionData = async (colUrl) => {
  const response = await axios.get(colUrl);
  const htmlData = document.createElement("div");
  htmlData.innerHTML = response.data;
  return htmlData.querySelector(".collection-template .collection__products-body");
};


// Mobile Filter exclusive
const closeBtn = document.querySelector("#mobilefilterClose");
const applyBtn = document.querySelector("#applyfilter");
const closingBtns = [closeBtn, applyBtn];
closingBtns.forEach((cb) => {
  cb.addEventListener("click", function(e) {
    this.closest(".collection__filter-mobile").classList.toggle("filteropen");
    this.closest(".collection-template").querySelector(".collection--darkbg").classList.remove("active");
  });
});

const openBtn = document.querySelector("#mobilefilterOpen");
openBtn.addEventListener("click", function(e) {
  this.closest(".collection-template").querySelector(".collection__filter-mobile").classList.toggle("filteropen");
  this.closest(".collection-template").querySelector(".collection--darkbg").classList.add("active");
});

const clearBtn = document.querySelector("#clearfilter");
clearBtn.addEventListener("click", function(e) {
  currentTags.splice(0, currentTags.length);
  this.closest(".collection__filter-mobile").querySelectorAll(".filteraction").forEach((fa) => {
    const checkboxChecked = fa.parentElement.classList.contains("general-checkbox") && fa.checked;
    const buttonChecked = fa.parentElement.classList.contains("filter-button__container") && fa.classList.contains("filteractive");
    if(checkboxChecked || buttonChecked) {
      fa.click();
    }
  });
});
